module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.tokenData.loading == false) ? _c('div', {
    style: ((_vm.globalVariables.showModal) ? 'overflow-y:hidden; height:' + _vm.deviceHeight + 'px!important' : '')
  }, [(_vm.tokenData.token !== null && _vm.user.userID > 0) ? _c('div', [_c('system-header'), _vm._v(" "), _c('system-sidebar')], 1) : _c('div', [_c('login-header'), _vm._v(" "), _c('system-content')], 1)]) : _vm._e(), _vm._v(" "), (_vm.tokenData.loading == true) ? _c('div', {
    staticClass: "empty"
  }) : _vm._e(), _vm._v(" "), _c('system-footer'), _vm._v(" "), _c('system-loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3572189d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 361
// module chunks = 44